import create from './create';

const accounts = create();
const { logout } = accounts;

export default logout;
